export default __webpack_public_path__ + "static/media/vc-commingsoon.9bb5f7ff.svg";